import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment, useEffect, useState } from "react";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import LinearProgress from "@mui/material/LinearProgress";
import { useSyncInfo } from "@plansoft-configuration-renderer/framework";
import { useIsNestedLayout } from "@plansoft-configuration-renderer/layout";
/**
 * Displays loading spinner while requests are open
 * @returns
 */
export function ConfigurationBackdrop(props) {
    const isNestedLayout = useIsNestedLayout();
    // do not render the backdrop in nested layout to prevent stacked backdrops
    if (isNestedLayout) {
        return _jsx(Fragment, {});
    }
    return _jsx(ConfigurationBackdropInner, Object.assign({}, props));
}
function ConfigurationBackdropInner(props) {
    const { isSyncing } = useSyncInfo();
    const [showBackdrop, setShowBackdrop] = useState(false);
    const { delayMs = 250 } = props;
    // effect that delays showing the backdrop
    useEffect(() => {
        let handle = 0;
        if (isSyncing) {
            handle = window.setTimeout(() => {
                setShowBackdrop(true);
            }, delayMs);
        }
        else {
            setShowBackdrop(false);
        }
        return () => {
            if (handle) {
                window.clearTimeout(handle);
            }
        };
    }, [isSyncing, delayMs]);
    return (_jsx(Backdrop, { open: showBackdrop, children: _jsx(ConfigurationBackdropProgress, Object.assign({}, props)) }));
}
/**
 * @private Used in layout builder
 * @param props
 */
export function ConfigurationBackdropProgress(props) {
    const { variant = "circular", progressColor = "primary" } = props;
    if (variant === "linear") {
        return (
        // needs minWidth, else it won't be visible at all inside a backdrop
        _jsx(Box, { sx: {
                minWidth: "50vw",
            }, children: _jsx(LinearProgress, { color: progressColor, variant: "indeterminate" }) }));
    }
    return _jsx(CircularProgress, { color: progressColor });
}
//# sourceMappingURL=ConfigurationBackdrop.js.map